<template>
  <div class="yxtbiz-face-selector">
    <div class="yxtbiz-face-selector_left">
      <div class="yxtbiz-face-selector_filter">
        <yxt-popover
          :append-to-body="false"
          popper-class="yxtbiz-face-selector_popover"
          placement="bottom-start"
          :visible-arrow="false"
          v-model="showMoreFilter"
        >
          <yxt-button slot="reference" plain class="yxtbiz-filter-btn mr12">
            <yxt-svg
              width="20px"
              height="20px"
              icon-class="filter"
              class="v-top"
            />
            <span class="ml8 v-top">{{
              $t('pc_biz_common_lbl_moreFilter' /* 更多筛选 */)
            }}</span>
            <i
              class="ml8"
              :class="showMoreFilter ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'"
            ></i>
          </yxt-button>
          <yxt-form :inline="true">
            <yxt-row :gutter="20">
              <yxt-col :span="14">
                <yxt-form-item
                  label-width="140px"
                  :label="$t('pc_biz_o2o_lbl_face_updatetime' /* 面授更新时间 */)"
                >
                  <yxt-date-picker
                    v-model="updateDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_ote_lbl_to')"
                    :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                    :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                    @change="(val) => handelChangeDate(val, 'update')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
              <yxt-col :span="10">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_o2o_lbl_face_source' /* 面授来源 */)"
                >
                  <yxt-select
                    v-model="selector.flipSource"
                    clearable
                    size="large"
                    :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
                    @change="getFaceList(true)"
                  >
                    <yxt-option
                      v-for="item in sourceList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></yxt-option>
                  </yxt-select>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>

            <yxt-row :gutter="20" class="mt16">
              <yxt-col :span="14">
                <yxt-form-item
                  label-width="140px"
                  :label="$t('pc_biz_o2o_lbl_face_starttime' /* 面授开始时间 */)"
                >
                  <yxt-date-picker
                    v-model="startDate"
                    format="yyyy-MM-dd"
                    type="daterange"
                    :range-separator="$t('pc_biz_ote_lbl_to')"
                    :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                    :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                    @change="(val) => handelChangeDate(val, 'start')"
                  >
                  </yxt-date-picker>
                </yxt-form-item>
              </yxt-col>
              <yxt-col :span="10">
                <yxt-form-item
                  label-width="100px"
                  :label="$t('pc_biz_o2o_lbl_face_status' /* 面授状态 */)"
                >
                  <yxt-select
                    v-model="selector.flipStatus"
                    clearable
                    size="large"
                    :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
                    @change="getFaceList(true)"
                  >
                    <yxt-option
                      v-for="item in statusList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></yxt-option>
                  </yxt-select>
                </yxt-form-item>
              </yxt-col>
            </yxt-row>
          </yxt-form>
        </yxt-popover>
        <!-- 机构 -->
        <!-- <yxtbiz-group-org-select
          v-if="isGroup"
          class="mr12"
          :clearable="false"
          :multiple="false"
          :functionCode="orgFunctionCode"
          :dataPermissionCode="orgDataPermissionCode"
          @change="changeOrg"
          setCurrentOrg
        ></yxtbiz-group-org-select> -->
        <yxt-input
          style="width: 208px"
          :placeholder="$t('pc_biz_o2o_lbl_select_face_name' /* 请输入面授名称 */)"
          v-model="selector.flipName"
          searchable
          maxlength="100"
          @search="getFaceList(true)"
        >
        </yxt-input>
      </div>
      <div class="yxtbiz-face-selector_main mt16 flex-1 h0">
        <yxt-table
          :ref="refTable"
          class="yxtbiz-face-selector_table"
          v-loading="loading"
          height="100%"
          :data="faceList"
          :default-sort="{ prop: 'updateTime', order: 'desc' }"
          @select-all="handelSelectPageAll"
          @select="handelSelect"
          @sort-change="handelSortChange"
        >
          <yxt-table-column
            type="selection"
            :show-overflow-tooltip="false"
            width="30"
            align="right"
            clear-padding="left-right"
          ></yxt-table-column>

          <!-- 面授名称 -->
          <yxt-table-column
            :label="$t('pc_biz_o2o_lbl_face_name' /* 面授名称 */)"
            show-overflow-tooltip
            align="left"
            width="180"
          >
            <template slot-scope="scope">
              {{ scope.row.flipName || '--' }}
            </template>
          </yxt-table-column>

          <!-- 状态 -->
          <yxt-table-column
            :label="$t('pc_biz_ote_lbl_status' /* 状态 */)"
            show-overflow-tooltip
            align="left"
            width="120"
          >
            <template slot-scope="scope">
              <span
                :class="[
                  'yxtbiz-face-selector_status',
                  `yxtbiz-face-selector_status${scope.row.status}`
                ]"
              ></span>
              <span>{{ scope.row.status ? statusList[scope.row.status-1].label : '--' }}</span>
            </template>
          </yxt-table-column>

          <!-- 创建人 -->
          <yxt-table-column
            :label="$t('pc_biz_lbl_creator' /* 创建人 */)"
            show-overflow-tooltip
            align="left"
            width="120"
          >
          <template slot-scope="scope">
              <yxtbiz-user-name :name="scope.row.createUserName" />
            </template>
          </yxt-table-column>

          <yxt-table-column
            :label="$t('pc_biz_global_lbl_updateTime' /* 更新时间 */)"
            prop="updateTime"
            sortable="custom"
            align="left"
          ></yxt-table-column>

        </yxt-table>
      </div>
      <div class="yxtbiz-face-selector_page">
        <yxt-button
          :loading="loadingAll"
          :disabled="faceList.length < 1"
          type="text"
          size="large"
          @click="handelSelectAll"
        >
          {{ $t('pc_biz_ote_btn_allselect') }}
        </yxt-button>
        <div class="flex-1">
          <yxt-pagination
            class="pull-right"
            :page-size="selector.limit"
            :total="count"
            :current-page="selector.current"
            @current-change="handelCurrentChange"
            layout="total, prev, pager, next"
            :page-count="totalPage"
          ></yxt-pagination>
        </div>
      </div>
    </div>
    <div class="yxtbiz-face-selector_right">
      <div v-if="max > 0" class="mb12">
        {{ $t('pc_biz_ote_lbl_chosenquestions') }}：{{ selectedList.length }}/{{
          max
        }}
      </div>
      <yxt-scrollbar :fit-height="true">
        <yxt-tag
          @close="deleteItem(item)"
          class="mr5 mb5"
          size="small"
          type="info"
          closable
          :key="item.flipId"
          v-for="item in selectedList"
        >
          <yxt-tooltip :content="item.flipName" :openFilter="true">
            <span class="yxtbiz-user-selector-tag">{{ item.flipName }}</span>
          </yxt-tooltip>
        </yxt-tag>
      </yxt-scrollbar>
      <yxt-button
        type="text"
        class="yxtbiz-user-clear font-size-12 color-gray-9 hover-primary-6"
        @click="clear"
        :disabled="selectedList.length < 1"
        >{{ $t('pc_biz_ote_btn_clearall') }}</yxt-button
      >
    </div>
  </div>
</template>

<script>
import { getFaceList } from './service';
import dateUtil from 'yxt-biz-pc/src/utils/date';
export default {
  name: 'YxtbizFaceSelector',
  name_zh: '选择面授',
  eventList: [
    {
      type: 'select',
      handler: 'onFaceSelect',
      label: '点击选择后的事件，选择的对象数组，包含属性：id：、name'
    }
  ],

  props: {
    value: {
      type: Array,
      default: () => {
        return [];
      },
      desc: '当前选择的对象',
      setter: 'JsonSetter'
    },
    max: {
      type: Number,
      default: 100,
      desc: '最大选择条数， 0 不限制',
      setter: 'NumberSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '考试面授权限导航编号',
      setter: 'StringSetter'
    },
    dataPermissionCode: {
      type: String,
      default: '',
      desc: '面授权限数据权限点',
      setter: 'StringSetter'
    },
    orgFunctionCode: {
      type: String,
      default: '',
      desc: '集团机构权限页面的导航编号',
      setter: 'StringSetter'
    },
    orgDataPermissionCode: {
      type: String,
      default: '',
      desc: '集团机构权限数据权限点',
      setter: 'StringSetter'
    },
    // 是否集团化，支持跨机构选择
    isGroup: {
      type: Boolean,
      default: false,
      desc: '是否集团化',
      setter: 'BooleanSetter'

    },
    limit: {
      type: Number,
      default: 50,
      desc: '每页限制条数',
      setter: 'NumberSetter'
    },
    orgId: {
      type: String,
      default: '',
      desc: 'orgId',
      setter: 'StringSetter'
    }
  },
  data() {
    return {
      selector: {
        orgId: this.orgId,
        current: 1,
        limit: 50,
        flipSource: '',
        flipStatus: '',
        flipName: '',
        orders: [
          {
            asc: false,
            column: 'updateTime'
          },
          {
            asc: false,
            column: 'flipId'
          }
        ],
        groupFuncReq: Number(this.isGroup),
        navCode: this.functionCode || this.orgFunctionCode,
        dataPermissionCode: this.dataPermissionCode || this.orgDataPermissionCode
      },
      loading: false,
      faceList: [],
      tableHeight: 0,
      totalPage: 0,
      loadingAll: false,
      count: 0,
      showMoreFilter: false,
      updateDate: '',
      startDate: '',
      sourceList: [
        {
          label: this.$t('pc_biz_nav_tip_train'/* 培训 */),
          value: 0
        },
        {
          label: this.$t('pc_biz_ote_lbl_talentdevelopment'/* 人才发展 */),
          value: 1
        },
        {
          label: this.$t('pc_biz_flip_center'/* 面授中心 */),
          value: 2
        }
      ],
      statusList: [
        {
          label: this.$t('pc_biz_global_processing'/* 进行中 */),
          value: 1
        },
        {
          label: this.$t('pc_biz_global_over'/* 已结束 */),
          value: 2
        }
      ],
      selected: new Map(),
      selectedList: [],
      refTable: 'table'
    };
  },
  created() {
    this.formatModel(this.value);
    this.getFaceList(true);
  },
  methods: {
    getFaceList(isFirst) {
      if (isFirst) {
        this.selector.current = 1;
      }
      this.loading = true;
      this.selector.limit = this.limit;
      getFaceList(this.selector).then(res => {
        this.faceList = res.records || [];
        this.count = res.total;
        // 设置选中项
        this.$nextTick(() => {
          this.setChecked();
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    handelCurrentChange(val) {
      this.selector.current = val;
      this.getFaceList();
    },
    // 单个选择
    handelSelect(selection, row) {
      let isAdd = selection.some(v => {
        return v.flipId === row.flipId;
      });
      this.selectCharge(isAdd, row);
      this.handelThrow();
    },
    // 选择本页
    handelSelectPageAll(selection) {
      let isAdd = selection.length > 0;
      this.faceList.forEach(item => {
        this.selectCharge(isAdd, item);
      });
      this.handelThrow();
    },

    // 筛选全部
    handelSelectAll() {
      this.selector.current = 1;
      this.selector.limit = this.max + 1;
      this.loading = true;
      getFaceList(this.selector).then(res => {
        let faceList = res.records || [];
        faceList.forEach(item => {
          if (this.selected.size >= this.max) {
            this.$message.warning(this.$t('pc_biz_msg_face_to_face_max', [this.max]/* 面授数量不能超过{0} */));
          } else {
            this.selected.set(item.flipId, item);
            let row = this.faceList.find(sitem => sitem.flipId === item.flipId);
            if (row) {
              this.$refs.table.toggleRowSelection(row, true);
            }
          }
        });
        this.handelThrow();
      }).finally(() => {
        this.loading = false;
      });
    },

    selectCharge(isAdd, row) {
      let selectCount = this.selected.size;
      if (isAdd) {
        if (selectCount >= this.max) {
          this.$message.warning(this.$t('pc_biz_msg_face_to_face_max', [this.max]/* 面授数量不能超过{0} */));
          this.$refs.table.toggleRowSelection(row, false);
        } else {
          this.selected.set(row.flipId, row);
        }
      } else {
        this.selected.delete(row.flipId);
      }
    },

    handelSortChange(sort) {
      this.selector.orders[0].asc = sort.order === 'asc';
      this.selector.orders[0].column = sort.prop;
      this.getFaceList();
      return false;
    },

    formatDate(row, col, val, index, formatType = 'yyyy-MM-dd HH:MM') {
      if (!val) return '';
      if (typeof val === 'string') {
        val = val.replace(/-/g, '/');
      }
      return dateUtil.format(new Date(val), formatType);
    },

    deleteItem(item) {
      let isDel = this.selected.has(item.flipId);
      if (isDel) {
        this.selected.delete(item.flipId);
        this.$refs.table.toggleRowSelection(item, false);
      }
      this.handelThrow();
    },

    clear() {
      this.selected = new Map();
      this.handelThrow();
      this.$refs.table.clearSelection();
    },

    setChecked() {
      this.faceList.forEach(obj => {
        if (this.selected.has(obj.flipId)) {
          this.$refs.table.toggleRowSelection(obj, true);
        } else {
          this.$refs.table.toggleRowSelection(obj, false);
        }
      });
    },

    formatModel(defaultData) {
      if (defaultData.length < 1) {
        return;
      };
      defaultData.forEach(obj => {
        this.selected.set(obj.flipId, obj);
      });
      this.selectedList = Array.from(this.selected.values());
    },

    handelThrow() {
      this.selectedList = Array.from(this.selected.values());
      this.$emit('select', this.selectedList);
    },

    changeOrg(org) {
      this.selector.orgId = org ? org.orgId : undefined;
      this.getFaceList(true);
    },

    formatCommitDate(date) {
      let getDate = date ? this.formatDate(null, null, date, null, 'yyyy-MM-dd') : '';
      return getDate;
    },

    handelChangeDate(val, timeType) {
      if (timeType === 'start') {
        this.selector.startDateFrom = this.formatCommitDate(val && val.length > 0 ? val[0] : '');
        this.selector.startDateTo = this.formatCommitDate(val && val.length > 1 ? val[1] : '');
      } else {
        this.selector.updateDateFrom = this.formatCommitDate(val && val.length > 0 ? val[0] : '');
        this.selector.updateDateTo = this.formatCommitDate(val && val.length > 1 ? val[1] : '');
      }
      this.getFaceList(true);
    }
  }
};
</script>


